(function () {
  'use strict';

  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var T = isFr
    ? { add: 'Ajouter au panier', adding: 'Ajout…', added: 'Ajouté ✓', options: 'Choisir les options', soldout: 'Épuisé', view: 'Voir le produit' }
    : { add: 'Add to cart', adding: 'Adding…', added: 'Added ✓', options: 'Choose options', soldout: 'Sold out', view: 'View product' };

  var SEND_TO_PAGE = ['corporate-gift-boxes', 'english-fish-glass-vase-large', 'gift-card', 'boutique-reyca-gift-card'];

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
    }
    return cache[handle];
  }

  function handleFromCard(card) {
    var q = card.querySelector('[data-product-card-handle]');
    if (q && q.getAttribute('data-product-card-handle')) return q.getAttribute('data-product-card-handle');
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function setState(btn, state, label) {
    btn.classList.remove('is-loading', 'is-added', 'is-soldout', 'is-options');
    if (state) btn.classList.add('is-' + state);
    btn.textContent = label;
  }

  function hasRealOptions(p) {
    return p.variants.length > 1 || (p.options && p.options.length && p.options[0].name !== 'Title');
  }

  function openQuickView(handle, variantId, url) {
    var tc = window.themeCore;
    if (tc && tc.EventBus && tc.QuickView) {
      tc.EventBus.emit('product-card:quick-view:clicked', { productHandle: handle, variant: variantId });
    } else {
      window.location.href = url;
    }
  }

  function addToCart(btn, variantId) {
    var tc = window.themeCore;
    btn.disabled = true;
    setState(btn, 'loading', T.adding);

    var request;
    if (tc && tc.CartApi) {
      request = tc.CartApi.makeRequest(tc.CartApi.actions.ADD_TO_CART, { id: variantId, quantity: 1 })
        .then(function () { return tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART); });
    } else {
      request = fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); });
    }

    request.then(function () {
      setState(btn, 'added', T.added);
      setTimeout(function () { btn.disabled = false; setState(btn, '', T.add); }, 2200);
    }).catch(function (err) {
      btn.disabled = false;
      setState(btn, '', T.add);
      var msg = err && (err.description || err.message);
      if (msg && tc && tc.CartNotificationError) {
        tc.CartNotificationError.addNotification(msg);
        tc.CartNotificationError.open();
      }
    });
  }

  function enhance(card) {
    if (card.hasAttribute('data-rq')) return;
    var handle = handleFromCard(card);
    if (!handle) return;
    card.setAttribute('data-rq', '1');

    var url = root + 'products/' + handle;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rq-add';
    btn.textContent = T.add;
    (card.querySelector('.product-card__main') || card.querySelector('.product-card__footer') || card).appendChild(btn);

    if (SEND_TO_PAGE.indexOf(handle) > -1) {
      setState(btn, 'options', T.view);
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); window.location.href = url; });
      return;
    }

    var product = null;
    getProduct(handle).then(function (p) {
      product = p;
      if (!p.available) { btn.disabled = true; setState(btn, 'soldout', T.soldout); }
      else if (hasRealOptions(p)) { setState(btn, 'options', T.options); }
    }).catch(function () { });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      var go = function (p) {
        if (!p) { window.location.href = url; return; }
        var v = p.variants.filter(function (x) { return x.available; })[0];
        if (!v) return;
        if (hasRealOptions(p)) openQuickView(handle, v.id, url);
        else addToCart(btn, v.id);
      };
      if (product) go(product);
      else getProduct(handle).then(go).catch(function () { window.location.href = url; });
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.product-card-new, .product-card.js-product-card').forEach(function (card) {
      if (!card.querySelector('a[href*="/products/"]')) return;
      enhance(card);
    });
  }

  function init() {
    scan();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { scan(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  'use strict';
  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var C = isFr ? {
    ship: 'Expédié en 1 à 2 jours ouvrables',
    deliver: 'Canada : 2 à 5 jours au Québec, 3 à 7 jours ailleurs au pays<br>États-Unis : 7 à 14 jours ouvrables<br>International (dont la France) : 2 à 6 semaines',
    returns: 'Retours? Simple comme bonjour!',
    returnsLink: 'Retours sous 14 jours',
    taxes: 'Livraison et taxes calculées au paiement.'
  } : {
    ship: 'Ships in 1–2 business days',
    deliver: 'Canada: 2–5 days in Quebec, 3–7 days elsewhere<br>United States: 7–14 business days<br>International (incl. France): 2–6 weeks',
    returns: 'Returns? Easy breezy!',
    returnsLink: '14-day returns',
    taxes: 'Shipping & taxes calculated at checkout.'
  };
  var truck = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>';
  var ret = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 7H4V2"/><path d="M4.5 7A8 8 0 1 1 4 12"/></svg>';

  function build() {
    var el = document.createElement('div');
    el.className = 'rq-info';
    el.innerHTML =
      '<div class="rq-info__row">' + truck + '<span><strong>' + C.ship + '</strong><br>' + C.deliver + '</span></div>' +
      '<div class="rq-info__row">' + ret + '<span>' + C.returns + ' <a href="' + root + 'policies/refund-policy">' + C.returnsLink + '</a></span></div>' +
      '<p class="rq-info__note">' + C.taxes + '</p>';
    return el;
  }

  function apply() {
    document.querySelectorAll('form.product-form .product-add-to-cart-new').forEach(function (atc) {
      var form = atc.closest('form');
      if (!form || form.querySelector('.rq-info')) return;
      atc.insertAdjacentElement('afterend', build());
      form.querySelectorAll('.product-sales-point-new').forEach(function (sp) {
        if (/breezy|shipping\s*&\s*taxes|livraison/i.test(sp.textContent)) sp.style.display = 'none';
      });
    });
  }

  function init() {
    apply();
    new MutationObserver(function () { apply(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  'use strict';
  function isSoldOut(item) {
    return !!item.querySelector('.product-card__label--sold-out, .rq-add.is-soldout');
  }
  function sortGrid(grid) {
    var items = Array.prototype.slice.call(grid.children).filter(function (el) { return el.classList.contains('collection__item'); });
    var sold = items.filter(isSoldOut);
    if (!sold.length) return;
    var lastInStock = null;
    items.forEach(function (el) { if (!isSoldOut(el)) lastInStock = el; });
    var firstSoldIdx = items.indexOf(sold[0]);
    var lastInIdx = lastInStock ? items.indexOf(lastInStock) : -1;
    if (firstSoldIdx > lastInIdx) return;
    sold.forEach(function (el) { grid.appendChild(el); });
  }
  var busy = false;
  function run() {
    if (busy) return; busy = true;
    document.querySelectorAll('.js-grid-wrapper').forEach(sortGrid);
    busy = false;
  }
  function init() {
    if (!document.querySelector('.js-grid-wrapper')) return;
    run();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  'use strict';
  var THRESHOLDS = { CA: 75, US: 100 };
  var S = window.Shopify || {};
  var country = (S.country || 'CA').toUpperCase();
  var base = THRESHOLDS[country];
  if (!base) return;

  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var cur = (S.currency && S.currency.active) || 'CAD';
  var rate = parseFloat((S.currency && S.currency.rate) || '1') || 1;
  var goalCents = Math.round(base * rate * 100);
  var root = (S.routes && S.routes.root) || '/';

  function money(cents) {
    var v = cents / 100;
    var digits = v % 1 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(isFr ? 'fr-CA' : (cur === 'USD' ? 'en-US' : 'en-CA'),
        { style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return '$' + v.toFixed(2); }
  }
  function text(total) {
    var left = goalCents - total;
    if (left <= 0) return isFr ? '<strong>Bonne nouvelle!</strong> Votre livraison est gratuite.' : '<strong>Good news!</strong> Your shipping is free.';
    return isFr ? 'Plus que <strong>' + money(left) + '</strong> pour la livraison gratuite'
                : 'You’re <strong>' + money(left) + '</strong> away from free shipping';
  }

  var total = null;
  function build() {
    var el = document.createElement('div');
    el.className = 'rq-ship';
    el.setAttribute('role', 'status');
    el.innerHTML = '<p class="rq-ship__msg"></p><div class="rq-ship__track"><span class="rq-ship__fill"></span></div>';
    return el;
  }
  function paint(el) {
    if (total === null) return;
    el.hidden = total <= 0;
    var pct = Math.max(0, Math.min(100, total / goalCents * 100));
    el.classList.toggle('is-free', pct >= 100);
    var msg = text(total);
    var m = el.querySelector('.rq-ship__msg');
    if (m.innerHTML !== msg) m.innerHTML = msg;
    el.querySelector('.rq-ship__fill').style.width = pct + '%';
  }
  function mount() {
    var h = document.querySelector('#CartDrawer .cart-drawer__heading');
    if (h && !(h.nextElementSibling && h.nextElementSibling.classList.contains('rq-ship'))) h.insertAdjacentElement('afterend', build());
    var page = document.querySelector('.shopify-section[id$="__cart-template"] form[action*="/cart"]');
    if (page && !page.parentNode.querySelector(':scope > .rq-ship')) page.insertAdjacentElement('beforebegin', build());
    document.querySelectorAll('.rq-ship').forEach(paint);
  }
  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.item_count > 0 ? c.total_price : 0; mount(); })
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  function init() {
    refresh();
    var tc = window.themeCore;
    if (tc && tc.EventBus && tc.EventBus.listen) {
      try { tc.EventBus.listen('cart:updated', function (c) {
        if (c && typeof c.total_price === 'number') { total = c.item_count > 0 ? c.total_price : 0; mount(); } else refresh();
      }); } catch (e) {}
    }
    var t;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.closest && (n.closest('#CartDrawer') || n.closest('.shopify-section[id$="__cart-template"]'))) {
          clearTimeout(t); t = setTimeout(refresh, 120); return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

(function () {
  'use strict';
  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var label = isFr ? 'Demander une soumission' : 'Request a quote';
  function apply() {
    document.querySelectorAll('.banner-with-text__text-content a[href*="corporate-gift-boxes"]:not(.rq-quote)').forEach(function (a) {
      var btn = document.createElement('a');
      btn.href = a.getAttribute('href');
      btn.className = 'rq-quote';
      btn.textContent = label;
      var p = a.closest('p') || a;
      var wrap = document.createElement('p');
      wrap.className = 'rq-quote-wrap';
      wrap.appendChild(btn);
      p.parentNode.replaceChild(wrap, p);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();

/* ---- Mobile product page: heart on the photo + Add to cart always reachable ---- */
(function(){'use strict';
function moveHeart(){
  if(window.innerWidth>=1200)return;
  var heart=document.querySelector('.rp-fav-heart--page'),media=document.querySelector('.product-media__container');
  if(heart&&media&&heart.parentNode!==media)media.appendChild(heart);
}
function update(){
  var bar=document.querySelector('.js-sticky-add-to-cart');
  if(!bar)return;
  if(window.innerWidth>=1200){bar.classList.remove('rq-show');return;}
  var main=document.querySelector('form[action*="/cart/add"] button.add-to-cart.button--block');
  if(!main)return;
  var r=main.getBoundingClientRect();
  bar.classList.toggle('rq-show',r.bottom<0||r.top>window.innerHeight-10);
}
function init(){
  if(!document.querySelector('.js-sticky-add-to-cart, .rp-fav-heart--page'))return;
  moveHeart();update();
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',function(){moveHeart();update();});
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){moveHeart();update();},100);}).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();})();
